export var ERRORS;
(function (ERRORS) {
    ERRORS["INVALID_CONFIG_PARAMS"] = "INVALID_CONFIG_PARAMS";
    ERRORS["REQUEST_5S_TIMEOUT"] = "REQUEST_5S_TIMEOUT";
    ERRORS["ETH_SIGNER_NOT_FOUND"] = "ETH_SIGNER_NOT_FOUND";
    ERRORS["AR_JWK_NOT_FOUND"] = "AR_JWK_NOT_FOUND";
    ERRORS["TO_NOT_FOUND"] = "TO_NOT_FOUND";
    ERRORS["SYMBOL_NOT_FOUND"] = "SYMBOL_NOT_FOUND";
    ERRORS["TAG_NOT_FOUND"] = "TAG_NOT_FOUND";
    ERRORS["TOKEN_NOT_FOUND"] = "TOKEN_NOT_FOUND";
    ERRORS["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ERRORS["EVERHASH_NOT_FOUND"] = "EVERHASH_NOT_FOUND";
    ERRORS["CHAIN_TX_HASH_NOT_FOUND"] = "CHAIN_TX_HASH_NOT_FOUND";
    ERRORS["INVALID_ACCOUNT_TYPE"] = "INVALID_ACCOUNT_TYPE";
    ERRORS["INVALID_ACTION"] = "INVALID_ACTION";
    ERRORS["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    ERRORS["WITHDRAW_AMOUNT_LESS_THAN_FEE"] = "WITHDRAW_AMOUNT_LESS_THAN_FEE";
    ERRORS["INSUFFICIENT_QUICK_WITHDRAWAL_AMOUNT"] = "INSUFFICIENT_QUICK_WITHDRAWAL_AMOUNT";
    ERRORS["WITHDRAW_TOKEN_NOT_SUPPORT_QUICK_MODE"] = "WITHDRAW_TOKEN_NOT_SUPPORT_QUICK_MODE";
    ERRORS["DEPOSIT_ARWEAVE_PST_MUST_BE_INTEGER"] = "DEPOSIT_ARWEAVE_PST_MUST_BE_INTEGER";
    ERRORS["PST_WITHDARW_TO_ARWEAVE_MUST_BE_INTEGER"] = "PST_WITHDARW_TO_ARWEAVE_MUST_BE_INTEGER";
})(ERRORS || (ERRORS = {}));
